export default "/static/dashboard/build/app/img/v2/c8d6f3742ace6c391bcbe43a92afb7f2.png";